import { render, staticRenderFns } from "./SalInfo.vue?vue&type=template&id=ac782894&scoped=true"
import script from "./SalInfo.vue?vue&type=script&lang=js"
export * from "./SalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac782894",
  null
  
)

export default component.exports